import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, FormControl, Link, Grid, IconButton, InputAdornment, OutlinedInput, SvgIcon, Button, Typography, Stack, Container, Icon, TextField, InputLabel, Divider, FormControlLabel, Checkbox, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material'
const loginLogo = `${process.env.REACT_APP_HOMEPAGE}assets/TJ-Logo-LightBG-withTagline 1.svg`;
import { forgotPassword, verifyOTP, changeNewPassword } from 'api/login';
import { useSnackbar } from 'components/snackbar';
import SlickSlider from 'react-slick';
import Typewriter from "typewriter-effect";

import SideBanner from 'components/basic-profile/SideBannerPage';
/**
 * Forgot password component
 * @returns {JSX.Element}
 * @constructor
 * @param {{ method: string }} location.state
 * @param {function} enqueueSnackbar
 * @param {function} navigate
 * @param {boolean} disable
 * @param {string} emailOrPhone
 * @param {string} error
 * @param {boolean} open
 * @param {boolean} showFlag
 */
const ForgotPassword = () => {
    const location = useLocation();
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const { method } = location.state;
    const [open, setOpen] = useState(false);
    const [emailOrPhone, setEmailOrPhone] = useState('');
    const [error, setError] = useState('');
    const [disable, setDisable] = useState(false);
    const [showFlag, setShowFlag] = useState(false);

    /**
     * Opens the OTP dialog.
     */

    const handleOpenOtpDialog = () => {
        setOpen(true);
    };

    /**
     * Closes the OTP dialog.
     */
    const handleClose = () => {
        setOpen(false);
    };
    /**
     * Hides the flag when the input field is blurred and empty.
     * Sets the showFlag state to false if emailOrPhone is an empty string.
     */

    const handleOnBlurFlag = () => {
        if (emailOrPhone === '') {
            setShowFlag(false);
        }
    }
    var settings = {
        autoplay: true,
        fade: true,
        autoplaySpeed: 3000,
        speed: 1000,
        prevArrow: false,
        nextArrow: false
    };

    /**
     * Handles the input change of the email or phone number input field.
     * It updates the emailOrPhone state and checks if the input is a valid phone number or email.
     * If it is a valid phone number, sets showFlag to true. Otherwise, sets showFlag to false.
     * @param {Event} e - The input event containing the value of the input field.
     */
    const handleFlag = (e) => {
        const value = event.target.value;
        setEmailOrPhone(value);

        const phoneRegex = /^\d+$/; // Regex to check if input is a phone number
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Regex to check if input is a valid email

        const isPhoneNumber = phoneRegex.test(value);
        setShowFlag(isPhoneNumber);
    }

    /**
     * Handles the input change of the email or phone number input field.
     * Updates the emailOrPhone state with the input value.
     * Validates the input to determine if it is a phone number or a valid email.
     * Sets the showFlag state to true if the input is a phone number.
     * Clears the error message if the input is valid; otherwise, sets an appropriate error message.
     * @param {Event} event - The input event containing the value of the input field.
     */

    const handleChange = (event) => {
        const value = event.target.value;
        setEmailOrPhone(value);

        const phoneRegex = /^\d+$/; // Regex to check if input is a phone number
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Regex to check if input is a valid email

        const isPhoneNumber = phoneRegex.test(value);
        setShowFlag(isPhoneNumber);

        if (isPhoneNumber) {
            setError('');
        } else if (emailRegex.test(value)) {
            setError('');
        } else {
            setError('Please enter a valid email address or WhatsApp number.');
        }
    };


    /**
     * Handles the submission of the forgot password form.
     * Validates the input to ensure it is a valid phone number or email address.
     * If valid, calls the forgotPassword API with the provided email or phone number.
     * Displays a success message and navigates to the appropriate page based on the method.
     * If invalid, sets an error message and does not call the API.
     * 
     * @async
     * @returns {void}
     */

    const onSubmit = async () => {
        const formData = { emailOrPhone, method };

        // Phone number regex (for 10 digits)
        const phoneRegex = /^\d{10}$/;

        // Email regex
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Validate phone or email
        if (!phoneRegex.test(emailOrPhone) && !emailRegex.test(emailOrPhone)) {
            setDisable(false);
            setError('Please enter a valid phone number or email address.');
            return;
        }
        let response
        if (formData?.emailOrPhone?.includes('@')) {
            response = await forgotPassword({ email: emailOrPhone.toLowerCase(), method: method });
        } else {
            response = await forgotPassword({ phone: emailOrPhone.toLowerCase(), method: method });
        }
        if (response?.success && response.data) {
            setDisable(true);
            enqueueSnackbar(response.message, { variant: 'success' });

            if (method === 'otp') {
                navigate('/enter-otp', { state: { method, user: response.data } });
            } else if (method === 'link') {
                navigate('/');
            }

        } else {
            enqueueSnackbar(response.message, { variant: 'error' });
        }
        setDisable(false);
    };

    return (
        <Box sx={{ overflow: 'hidden' }}>
            <Box>
                <Grid container justifyContent={'center'} alignItems={'center'}>
                    <Grid item xs={12} md={6} lg={6} >
                        <Box className="login-page-wrapper">
                            <Box className="login-content-wrapper" sx={{ padding: { xs: '40px 20px!important', md: '40px!important' } }}>
                                <Box className="tj-logo" sx={{ marginBottom: { xs: '24px', md: '40px' } }}>
                                    <Box
                                        component="img"
                                        alt="Talent Junction"
                                        src={loginLogo}
                                    />
                                </Box>

                                {/* Register form block */}
                                <Box className="register-form-wrapper forgot-password-form">
                                    <Box sx={{ marginBottom: { xs: '24px', md: '40px' } }}>
                                        <Stack spacing={'4px'}>
                                            <Typography className="title">
                                                {method === 'otp' && "Login using OTP"}
                                                {method === 'link' && "Reset Password"}
                                                {!method && "No method specified. Please select any method."}
                                            </Typography>
                                            <Typography className="info-text">
                                                {method === 'otp' && "Please enter your registered WhatsApp number or email address to receive OTP"}
                                                {method === 'link' && `To receive reset password link, please enter your registered WhatsApp number or email address`}
                                                {!method && "No option specified. Please select any method."}
                                            </Typography>
                                        </Stack>
                                    </Box>

                                    <Stack spacing={2.5}>
                                        <FormControl size="small" fullWidth
                                            sx={{
                                                display: 'inline-flex',
                                                flexDirection: 'column',
                                                position: 'relative',
                                                minWidth: '0px',
                                                padding: '0px',
                                                margin: '0px',
                                                border: '0px',
                                                verticalAlign: 'top',
                                                width: '100%',
                                                height: '67px',
                                            }} >
                                            <InputLabel htmlFor="outlined-adornment-password">Email Address / WhatsApp Number</InputLabel>
                                            <OutlinedInput
                                                id="outlined-adornment-password"
                                                label='Email Address / WhatsApp Number'
                                                value={emailOrPhone}
                                                onFocus={handleFlag}
                                                onChange={handleChange}
                                                onBlur={handleOnBlurFlag}
                                                inputProps={{
                                                    style: {
                                                        paddingLeft: showFlag ? '80px' : '16px',
                                                    },
                                                }}
                                            />
                                            {error && (
                                                <Box sx={{ marginBottom: "-1px" }}>
                                                    <Typography className="error-text" size="small" component="p" style={{ color: "#FF4842", fontSize: "0.75rem", fontFamily: "Public Sans, sans-serif", fontWeight: 400, marginLeft: "14px" }}>
                                                        {error}
                                                    </Typography>
                                                </Box>
                                            )}

                                            {showFlag &&
                                                <InputAdornment position="start">
                                                    <Box className="iti-flag-container" sx={{ marginTop: "-3px" }}>
                                                        <Stack direction="row" alignItems={'center'} spacing={1}>
                                                            <Box className="iti-flag" ></Box>
                                                            <Box className="selected-dial-code">+91</Box>
                                                            <Divider orientation="vertical" variant="middle" flexItem />
                                                        </Stack>
                                                    </Box>
                                                </InputAdornment>
                                            }
                                        </FormControl>
                                        <Button
                                            type='submit'
                                            variant='contained'
                                            size='large'
                                            disableElevation
                                            className="login-btn"
                                            disabled={disable}
                                            onClick={() => {
                                                setDisable(true);
                                                onSubmit();
                                            }}
                                        >
                                            {method === 'otp' && " Send OTP"}
                                            {method === 'link' && "Send Reset Password Link"}
                                            {!method && "No method specified. Please select any method."}
                                        </Button>
                                        <Box>
                                            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems="center">
                                                <Typography component="p" sx={{ fontSize: "14px" }}>
                                                    Already registered?&nbsp;
                                                    <Link onClick={() => navigate('/')} sx={{ cursor: 'pointer' }} underline="none">
                                                        Login
                                                    </Link>
                                                </Typography>

                                                <Typography component="p" sx={{ fontSize: "14px" }}>
                                                    Haven’t registered?&nbsp;
                                                    <Link onClick={() => navigate('/register')} sx={{ cursor: 'pointer' }} underline="none">
                                                        Register
                                                    </Link>
                                                </Typography>
                                            </Stack>
                                        </Box>

                                    </Stack>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={6} lg={6} sx={{ display: { xs: 'none', md: 'block' } }}>
                        <SideBanner />
                    </Grid>
                </Grid>
            </Box>

        </Box>
    )
}

export default ForgotPassword
